// Base API URL for contact endpoints
const API_BASE_URL = 'https://xoxl3mvo9e.execute-api.us-east-1.amazonaws.com/prod';

/**
 * Send a contact form message
 * @param {Object} contactData - Contact form data
 * @param {string} contactData.name - Sender's name
 * @param {string} contactData.email - Sender's email
 * @param {string} contactData.subject - Message subject
 * @param {string} contactData.message - Message content
 * @returns {Promise<Object>} - Result of the contact submission
 */
export const sendContactMessage = async (contactData) => {
  try {
    const { name, email, subject, message } = contactData;

    // Validate required fields
    if (!name || !email || !subject || !message) {
      throw new Error('All fields are required');
    }

    const response = await fetch(`${API_BASE_URL}/contact`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        name,
        email,
        subject,
        message
      }),
    });

    if (!response.ok) {
      let errorText;
      try {
        const errorData = await response.json();
        errorText = errorData.message || JSON.stringify(errorData);
      } catch (e) {
        errorText = await response.text();
      }
      throw new Error(`Failed to send message: ${errorText}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error sending contact message:', error);
    throw error;
  }
};

export default {
  sendContactMessage
};